{
  "title": "Notifications",
  "bell": {
    "label": "Notifications",
    "unread": "{{unreadValue}} non lue(s)",
    "empty": "Aucune notification pour l'instant.",
    "seeAll": "Tout voir",
    "markAllRead": "Tout marquer comme lu"
  },
  "list": {
    "empty": "Vous n'avez aucune notification.",
    "emptyUnread": "Vous n'avez aucune notification non lue.",
    "unreadOnly": "Non lues seulement",
    "markRead": "Marquer comme lu",
    "delete": "Supprimer",
    "loadMore": "Charger plus"
  },
  "types": {
    "learning.enrolled": {
      "title": "Inscription confirmée",
      "body": "Vous êtes inscrit au cours « {{courseTitle}} »."
    },
    "learning.new_student": {
      "title": "Nouvel élève",
      "body": "Un élève vient de s'inscrire à « {{courseTitle}} »."
    },
    "learning.attempt_to_grade": {
      "title": "Une copie à corriger",
      "body": "Une copie vous attend dans « {{courseTitle}} »."
    },
    "learning.attempt_graded": {
      "title": "Votre copie est corrigée",
      "body": "Votre copie pour « {{courseTitle}} » a été corrigée."
    },
    "learning.attempts_reset": {
      "title": "De nouveaux essais",
      "body": "Votre enseignant vous a accordé de nouveaux essais dans « {{courseTitle}} »."
    },
    "learning.course_completed": {
      "title": "Cours terminé",
      "body": "Félicitations, vous avez terminé « {{courseTitle}} »."
    },
    "billing.subscription_activated": {
      "title": "Abonnement actif",
      "body": "Votre abonnement ({{planCode}}) est actif."
    },
    "unknown": {
      "title": "Notification",
      "body": "Cette notification ne peut pas être affichée par cette version de l'application."
    },
    "messaging.new_message": {
      "title": "Nouveau message",
      "body": "{{senderName}} vous a écrit."
    },
    "admin.warning": {
      "title": "Avertissement",
      "body": "Un contenu que vous avez publié a été signalé et examiné."
    },
    "learning.certificate_issued": {
      "title": "Votre attestation",
      "body": "Votre attestation pour « {{courseTitle}} » est disponible (n° {{serial}})."
    },
    "admin.role_granted": {
      "title": "Nouvel administrateur",
      "body": "Le compte « {{promotedName}} » a reçu le rôle d'administrateur."
    }
  },
  "preferences": {
    "title": "Préférences de notification",
    "intro": "Choisissez comment vous souhaitez être prévenu. Le journal dans l'application ne peut pas être désactivé.",
    "channel": {
      "in_app": "Dans l'application",
      "email": "Par email"
    },
    "locked": "Ne peut pas être désactivé",
    "saved": "Préférences enregistrées.",
    "saveFailed": "Les préférences n'ont pas pu être enregistrées."
  }
}
